import { toString30pk9tzaqopn as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Entry2xmjmyutzoq3p as Entry } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MAP_getInstanceoecfbvb4e1b6 as MAP_getInstance } from '../descriptors/SerialKinds.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../descriptors/SerialDescriptors.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Paire9pteg33gng7 as Pair,
  to2cs3ny02qtbcb as to,
  Triple1vhi3d0dgpnjb as Triple,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
var MapEntryClass;
function MapEntry() {
  if (MapEntryClass === VOID) {
    class $ {
      constructor(key, value) {
        this.u26_1 = key;
        this.v26_1 = value;
      }
      r3() {
        return this.u26_1;
      }
      s3() {
        return this.v26_1;
      }
      toString() {
        return 'MapEntry(key=' + toString(this.u26_1) + ', value=' + toString(this.v26_1) + ')';
      }
      hashCode() {
        var result = this.u26_1 == null ? 0 : hashCode(this.u26_1);
        result = imul(result, 31) + (this.v26_1 == null ? 0 : hashCode(this.v26_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MapEntry()))
          return false;
        if (!equals(this.u26_1, other.u26_1))
          return false;
        if (!equals(this.v26_1, other.v26_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MapEntry', VOID, VOID, [Entry()]);
    MapEntryClass = $;
  }
  return MapEntryClass;
}
var MapEntrySerializerClass;
function MapEntrySerializer() {
  if (MapEntrySerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        var tmp_0 = MAP_getInstance();
        tmp.y26_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], ($this$buildSerialDescriptor) => {
          $this$buildSerialDescriptor.q1n('key', keySerializer.x1m());
          $this$buildSerialDescriptor.q1n('value', valueSerializer.x1m());
          return Unit_instance;
        });
      }
      x1m() {
        return this.y26_1;
      }
      z26(_this__u8e3s4) {
        return _this__u8e3s4.r3();
      }
      a27(_this__u8e3s4) {
        return this.z26((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      b27(_this__u8e3s4) {
        return _this__u8e3s4.s3();
      }
      c27(_this__u8e3s4) {
        return this.b27((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry()) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      d27(key, value) {
        return new (MapEntry())(key, value);
      }
    }
    initMetadataForClass($, 'MapEntrySerializer');
    MapEntrySerializerClass = $;
  }
  return MapEntrySerializerClass;
}
var PairSerializerClass;
function PairSerializer() {
  if (PairSerializerClass === VOID) {
    class $ extends KeyValueSerializer() {
      constructor(keySerializer, valueSerializer) {
        super(keySerializer, valueSerializer);
        var tmp = this;
        tmp.j27_1 = buildClassSerialDescriptor('kotlin.Pair', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.q1n('first', keySerializer.x1m());
          $this$buildClassSerialDescriptor.q1n('second', valueSerializer.x1m());
          return Unit_instance;
        });
      }
      x1m() {
        return this.j27_1;
      }
      k27(_this__u8e3s4) {
        return _this__u8e3s4.bf_1;
      }
      a27(_this__u8e3s4) {
        return this.k27(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      l27(_this__u8e3s4) {
        return _this__u8e3s4.cf_1;
      }
      c27(_this__u8e3s4) {
        return this.l27(_this__u8e3s4 instanceof Pair() ? _this__u8e3s4 : THROW_CCE());
      }
      d27(key, value) {
        return to(key, value);
      }
    }
    initMetadataForClass($, 'PairSerializer');
    PairSerializerClass = $;
  }
  return PairSerializerClass;
}
function decodeSequentially($this, composite) {
  var a = composite.b1s($this.p27_1, 0, $this.m27_1);
  var b = composite.b1s($this.p27_1, 1, $this.n27_1);
  var c = composite.b1s($this.p27_1, 2, $this.o27_1);
  composite.p1r($this.p27_1);
  return new (Triple())(a, b, c);
}
function decodeStructure($this, composite) {
  var a = get_NULL();
  var b = get_NULL();
  var c = get_NULL();
  mainLoop: while (true) {
    var index = composite.f1s($this.p27_1);
    switch (index) {
      case -1:
        break mainLoop;
      case 0:
        a = composite.b1s($this.p27_1, 0, $this.m27_1);
        break;
      case 1:
        b = composite.b1s($this.p27_1, 1, $this.n27_1);
        break;
      case 2:
        c = composite.b1s($this.p27_1, 2, $this.o27_1);
        break;
      default:
        throw SerializationException().s1o('Unexpected index ' + index);
    }
  }
  composite.p1r($this.p27_1);
  if (a === get_NULL())
    throw SerializationException().s1o("Element 'first' is missing");
  if (b === get_NULL())
    throw SerializationException().s1o("Element 'second' is missing");
  if (c === get_NULL())
    throw SerializationException().s1o("Element 'third' is missing");
  var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
  var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
  return new (Triple())(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
}
var TripleSerializerClass;
function TripleSerializer() {
  if (TripleSerializerClass === VOID) {
    class $ {
      constructor(aSerializer, bSerializer, cSerializer) {
        this.m27_1 = aSerializer;
        this.n27_1 = bSerializer;
        this.o27_1 = cSerializer;
        var tmp = this;
        tmp.p27_1 = buildClassSerialDescriptor('kotlin.Triple', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.q1n('first', this.m27_1.x1m());
          $this$buildClassSerialDescriptor.q1n('second', this.n27_1.x1m());
          $this$buildClassSerialDescriptor.q1n('third', this.o27_1.x1m());
          return Unit_instance;
        });
      }
      x1m() {
        return this.p27_1;
      }
      q27(encoder, value) {
        var structuredEncoder = encoder.o1r(this.p27_1);
        structuredEncoder.g1t(this.p27_1, 0, this.m27_1, value.kt_1);
        structuredEncoder.g1t(this.p27_1, 1, this.n27_1, value.lt_1);
        structuredEncoder.g1t(this.p27_1, 2, this.o27_1, value.mt_1);
        structuredEncoder.p1r(this.p27_1);
      }
      y1m(encoder, value) {
        return this.q27(encoder, value instanceof Triple() ? value : THROW_CCE());
      }
      z1m(decoder) {
        var composite = decoder.o1r(this.p27_1);
        if (composite.e1s()) {
          return decodeSequentially(this, composite);
        }
        return decodeStructure(this, composite);
      }
    }
    initMetadataForClass($, 'TripleSerializer', VOID, VOID, [KSerializer()]);
    TripleSerializerClass = $;
  }
  return TripleSerializerClass;
}
var KeyValueSerializerClass;
function KeyValueSerializer() {
  if (KeyValueSerializerClass === VOID) {
    class $ {
      constructor(keySerializer, valueSerializer) {
        this.e27_1 = keySerializer;
        this.f27_1 = valueSerializer;
      }
      g27(encoder, value) {
        var structuredEncoder = encoder.o1r(this.x1m());
        structuredEncoder.g1t(this.x1m(), 0, this.e27_1, this.a27(value));
        structuredEncoder.g1t(this.x1m(), 1, this.f27_1, this.c27(value));
        structuredEncoder.p1r(this.x1m());
      }
      y1m(encoder, value) {
        return this.g27(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
      }
      z1m(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.x1m();
        var composite = decoder.o1r(descriptor);
        var tmp$ret$0;
        $l$block: {
          if (composite.e1s()) {
            var key = composite.b1s(this.x1m(), 0, this.e27_1);
            var value = composite.b1s(this.x1m(), 1, this.f27_1);
            tmp$ret$0 = this.d27(key, value);
            break $l$block;
          }
          var key_0 = get_NULL();
          var value_0 = get_NULL();
          mainLoop: while (true) {
            var idx = composite.f1s(this.x1m());
            switch (idx) {
              case -1:
                break mainLoop;
              case 0:
                key_0 = composite.b1s(this.x1m(), 0, this.e27_1);
                break;
              case 1:
                value_0 = composite.b1s(this.x1m(), 1, this.f27_1);
                break;
              default:
                throw SerializationException().s1o('Invalid index: ' + idx);
            }
          }
          if (key_0 === get_NULL())
            throw SerializationException().s1o("Element 'key' is missing");
          if (value_0 === get_NULL())
            throw SerializationException().s1o("Element 'value' is missing");
          var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
          tmp$ret$0 = this.d27(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
        }
        var result = tmp$ret$0;
        composite.p1r(descriptor);
        return result;
      }
    }
    initMetadataForClass($, 'KeyValueSerializer', VOID, VOID, [KSerializer()]);
    KeyValueSerializerClass = $;
  }
  return KeyValueSerializerClass;
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
//region block: exports
export {
  MapEntrySerializer as MapEntrySerializer2ukwamih4zw76,
  PairSerializer as PairSerializerpzh6nuee9oov,
  TripleSerializer as TripleSerializer25andm5j3t9nu,
};
//endregion

//# sourceMappingURL=Tuples.mjs.map
